"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var Types_1 = require("@CommonFrontendBackend/Onboarding/Types");
var Tour_1 = require("@CommonFrontendBackend/Tour");
var react_1 = __importDefault(require("react"));
var TourComponents_1 = require("./TourComponents");
var TourTypes_1 = require("./TourTypes");
var mobx_1 = require("mobx");
var CommonUtils_1 = require("@CommonFrontendBackend/Utils/CommonUtils");
var AutomationHubspotTour = (function (_super) {
    __extends(AutomationHubspotTour, _super);
    function AutomationHubspotTour(rootDataStore, overlayStack) {
        var _this = _super.call(this) || this;
        _this.rootDataStore = rootDataStore;
        _this.overlayStack = overlayStack;
        _this.tourId = Tour_1.TourId.AutomationHubspot;
        _this.telemetryId = "automation-hubspot";
        _this.title = "Integrate your CRM & start automating";
        _this.image = "tour-automation.png";
        _this.welcomeDescription = "Take a quick guided tour to connect your CRM and automate your first Qwilr page";
        _this.steps = __spreadArray(__spreadArray([], __read((0, CommonUtils_1.includeIf)(_this.rootDataStore.userDataStore.isAdmin, [
            {
                step: Tour_1.AutomationHubspotStepsId.ConnectToHubspot,
                title: "Connect to HubSpot",
                description: (react_1.default.createElement(react_1.default.Fragment, null,
                    "Click ",
                    react_1.default.createElement(TourComponents_1.Strong, null, "Enable HubSpot"),
                    " and follow the steps to connect to Qwilr. Your HubSpot account email must be exactly the same as your Qwilr account email for this to work. Click the logo to return to the dashboard.")),
                stepType: TourTypes_1.TourStepConfigurationType.Regular,
                video: "automation-hubspot/connect-to-hubspot-rearranged.mp4",
                videoLarge: "automation-hubspot/connect-to-hubspot-rearranged-large.mp4",
            },
        ])), false), [
            {
                step: Tour_1.AutomationHubspotStepsId.CreateAPage,
                title: "Create a page",
                description: (react_1.default.createElement(react_1.default.Fragment, null,
                    "Click ",
                    react_1.default.createElement(TourComponents_1.Strong, null, "Create new"),
                    " and choose ",
                    react_1.default.createElement(TourComponents_1.Strong, null, "From template"),
                    " to start with some sample content, or ",
                    react_1.default.createElement(TourComponents_1.Strong, null, "Blank page"),
                    " to start fresh. This will be the starting point for your own template.")),
                stepType: TourTypes_1.TourStepConfigurationType.Regular,
                video: "automation-hubspot/create-a-page-rearranged.mp4",
                videoLarge: "automation-hubspot/create-a-page-rearranged-large.mp4",
            },
            {
                step: Tour_1.AutomationHubspotStepsId.ConvertToTemplate,
                title: "Convert to a CRM template",
                description: (react_1.default.createElement(react_1.default.Fragment, null,
                    "Click the ",
                    react_1.default.createElement(TourComponents_1.Strong, null, "Convert to Template"),
                    " button (top right corner). Then click the",
                    " ",
                    react_1.default.createElement(TourComponents_1.Strong, null, "Tokens"),
                    " button and choose the ",
                    react_1.default.createElement(TourComponents_1.Strong, null, "CRM"),
                    " tab. Follow the prompts from there to create your template. If you have any issues, check out our",
                    " ",
                    react_1.default.createElement(TourComponents_1.Link, { href: "https://guides.qwilr.com/Guide-Qwilr-HubSpot-sKzHy5I9TjC5" }, "step by step guide"),
                    ".")),
                stepType: TourTypes_1.TourStepConfigurationType.Regular,
                video: "automation-hubspot/convert-to-template.mp4",
                videoLarge: "automation-hubspot/convert-to-template-large.mp4",
            },
            {
                step: Tour_1.AutomationHubspotStepsId.AddTokens,
                title: "Add tokens",
                description: "Tokens mark the points in your template where Qwilr will pull information from your CRM record. Each token connects to a specific CRM field. When you’re in your CRM creating a new Qwilr Page, it will personalize automatically.",
                stepType: TourTypes_1.TourStepConfigurationType.Regular,
                video: "automation-hubspot/add-tokens.mp4",
                videoLarge: "automation-hubspot/add-tokens-large.mp4",
            },
            {
                step: Tour_1.AutomationHubspotStepsId.GeneratePage,
                title: "Generate your page",
                description: (react_1.default.createElement(react_1.default.Fragment, null,
                    "Head over to HubSpot and open up a record. Click the ",
                    react_1.default.createElement(TourComponents_1.Strong, null, "Create Qwilr"),
                    " button in the sidebar and follow the steps to select the template you just created and generate your first page.")),
                stepType: TourTypes_1.TourStepConfigurationType.Regular,
                video: "automation-hubspot/generate-page.mp4",
                videoLarge: "automation-hubspot/generate-page-large.mp4",
            },
            {
                step: Tour_1.AutomationHubspotStepsId.AutomationTourComplete,
                title: "🎉 Automation tour completed!",
                description: (react_1.default.createElement(react_1.default.Fragment, null,
                    "You\u2019re all set up to automate with your CRM. Check out the",
                    " ",
                    react_1.default.createElement(TourComponents_1.Link, { href: "https://guides.qwilr.com/Guide-Qwilr-HubSpot-sKzHy5I9TjC5" }, "HubSpot guide"),
                    " to see what else you can do with the integration, or view the ",
                    react_1.default.createElement(TourComponents_1.Link, { href: "#/settings/integrations" }, "integrations page"),
                    " to connect with more tools.")),
                stepType: TourTypes_1.TourStepConfigurationType.Completion,
            },
        ], false);
        return _this;
    }
    Object.defineProperty(AutomationHubspotTour.prototype, "priority", {
        get: function () {
            var isHubspotSelected = this.rootDataStore.getAccountDataStore().census.crmTechnology === Types_1.CrmOptionId.Hubspot;
            var isHubspotEnabled = this.rootDataStore.getAccountDataStore().integrations.hubspot.enabled;
            return {
                order: isHubspotSelected && !isHubspotEnabled ? 50 : 0,
            };
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AutomationHubspotTour.prototype, "enabled", {
        get: function () {
            return (this.rootDataStore.userDataStore.isAdmin || this.rootDataStore.getAccountDataStore().integrations.hubspot.enabled);
        },
        enumerable: false,
        configurable: true
    });
    AutomationHubspotTour.prototype.onTourStart = function () {
        this.overlayStack.closeAll();
        var tourStartUrl;
        if (this.defaultStartingStep === Tour_1.AutomationHubspotStepsId.ConnectToHubspot) {
            tourStartUrl = "#/settings/integrations/hubspot";
        }
        else if (this.defaultStartingStep === Tour_1.AutomationHubspotStepsId.CreateAPage) {
            tourStartUrl = "#/pages";
        }
        if (!window.location.hash.startsWith(tourStartUrl)) {
            window.location.href = tourStartUrl;
        }
    };
    Object.defineProperty(AutomationHubspotTour.prototype, "defaultStartingStep", {
        get: function () {
            var isHubspotEnabled = this.rootDataStore.getAccountDataStore().integrations.hubspot.enabled;
            if (!isHubspotEnabled) {
                return Tour_1.AutomationHubspotStepsId.ConnectToHubspot;
            }
            else {
                return Tour_1.AutomationHubspotStepsId.CreateAPage;
            }
        },
        enumerable: false,
        configurable: true
    });
    var _a;
    __decorate([
        mobx_1.computed,
        __metadata("design:type", typeof (_a = typeof TourTypes_1.TourPriority !== "undefined" && TourTypes_1.TourPriority) === "function" ? _a : Object),
        __metadata("design:paramtypes", [])
    ], AutomationHubspotTour.prototype, "priority", null);
    return AutomationHubspotTour;
}(TourTypes_1.Tour));
exports.default = AutomationHubspotTour;
